import React, { useState } from "react";

import "./Styles.css";

import HomePageTextContent from "../../Components/HomePageTextContent/HomePageTextContent";
import ButtonGenerator from "../../Components/ButtonFactory/ButtonGenerator";
import { LazyLoadImage } from "react-lazy-load-image-component";

// import PstMrtmFormModal from "../../Components/PstMrtmFormModal/PstMrtmFormModal";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import image from "../../assets/Images/LauraMaersk_july2023_2204_compressed.webp";

function Home() {
  const [showFormModal, setShowFormModal] = useState(false);

  const handleShowFormClick = () => {
    setShowFormModal(true);
  };

  const navigate = useNavigate();
  const navigateToOnGoingPostmortemPage = () => {
    navigate("/ongoing-postmortems");
  };

  const navigateToInsightsPage = () => {
    navigate("/insights");
  };

  const navigateToCreatePostmortemPage = () => {
    navigate("/create");
  };

  const navigateToArchivedPostmortems = () => {
    navigate("/archived-postmortems");
  };

  const navigateToPostmortemInsights = () => {
    window.open("https://app.powerbi.com/groups/me/reports/fe807a1c-5338-4153-8064-7f178ea22568/ReportSection?ctid=05d75c05-fa1a-42e7-9cf1-eb416c396f2d&experience=power-bi", "_blank");
  }

  const navigateToInsightsDashboard = () => {
    navigate("/insights-dashboard");
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "93.6%",
          zIndex: "-1000",
        }}
      >
        <LazyLoadImage
          effect="blur"
          alt={"background-image"}
          height={"100%"}
          src={image} // use normal <img> attributes as props
          width={"100%"}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingRight: "90px",
        }}
        className="homePage-Wrapper"
      >
        <div
          style={{
            width: "70%",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: "20px",
          }}
        >
          <HomePageTextContent />

          <Container fluid>
            <Row
              className="justify-content-center align-items-center"
              xxl="auto"
            >
              <Col
                xxl="auto"
                // xl={6}
                className={"d-flex justify-content-center second-step mt-2"}
              >
                <ButtonGenerator
                  appearance="primary"
                  id="primary"
                  justifyItems="center"
                  label="OnGoing Post-mortems"
                  name="primary"
                  onClick={() => navigateToOnGoingPostmortemPage()}
                  title="OnGoing Post-mortems"
                  variant="primary"
                  // linkTo=""
                  // style={{backgroundColor: "#B5E0F5"}}
                />
              </Col>

              <Col
                className="d-flex justify-content-center mt-2"
                // className={getClasses()}
                xxl="auto"
                // xl={6}
              >
                <div
                  onClick={() => navigateToArchivedPostmortems()}
                  className="home_buttonWrapper fifth-step"
                >
                  <button style={{ color: "white" }} className="btn">
                    Archived Post-mortems
                  </button>
                </div>
              </Col>
            </Row>

            <Row
              className="justify-content-center align-items-center"
              xxl="auto"
            >
              <Col
                xxl="auto"
                // xl={6}
                className={"d-flex justify-content-center second-step mt-2"}
              >
                <ButtonGenerator
                  appearance="primary"
                  id="primary"
                  justifyItems="center"
                  label="Create Post-Mortem (For Incidents managed outside ServiceNow)"
                  name="primary"
                  onClick={() => navigateToCreatePostmortemPage()}
                  title="OnGoing Post-mortems"
                  variant="primary"
                  // linkTo=""
                  // style={{backgroundColor: "#B5E0F5"}}
                />
              </Col>

              {/* Temporarily hidden - Power BI button */}
              {/* <Col
                className="d-flex justify-content-center mt-2"
                // className={getClasses()}
                xxl="auto"
                // xl={6}
              >
                <ButtonGenerator
                  appearance="primary"
                  id="primary"
                  justifyItems="center"
                  label="Postmortem Insights (Power BI)"
                  name="primary"
                  onClick={() => navigateToPostmortemInsights()}
                  title="OnGoing Post-mortems"
                  variant="primary"
                  // linkTo=""
                  // style={{backgroundColor: "#B5E0F5"}}
                />
              </Col> */}

              <Col
                className="d-flex justify-content-center mt-2"
                // className={getClasses()}
                xxl="auto"
                // xl={6}
              >
                <ButtonGenerator
                  appearance="primary"
                  id="primary"
                  justifyItems="center"
                  label="Postmortem Insights Dashboard"
                  name="primary"
                  onClick={() => navigateToInsightsDashboard()}
                  title="Postmortem Insights Dashboard"
                  variant="primary"
                  // linkTo=""
                  // style={{backgroundColor: "#B5E0F5"}}
                />
              </Col>
            </Row>

            {/* <Row style={{ width: "100%" }} className="">
              <Col
                className={"mt-2 d-flex justify-content-center fourth-step"}
                xxl="auto"
                // xl={6}
                // style={{ marginLeft: "auto", marginRight: "auto" }}
              >
                <div
                  // style={{background:"rgba(0, 36, 61, 0.5)"}}
                  className="home_buttonWrapper fifth-step"
                >
                  <button
                    onClick={() => navigateToCreatePostmortemPage()}
                    disabled={false}
                    style={{ color: "white" }}
                    className="btn"
                  >
                    Create Post-Mortem
                    <br />
                    (For Incidents managed outside ServiceNow)
                  </button>
                </div>
              </Col>
              <Col>
              <div
                  // style={{background:"rgba(0, 36, 61, 0.5)"}}
                  className="home_buttonWrapper fifth-step"
                >
                  <button
                    onClick={() => navigateToCreatePostmortemPage()}
                    disabled={false}
                    style={{ color: "white" }}
                    className="btn"
                  >
                    Postmortem Insights
                    <br />
    
                  </button>
                </div>
              </Col>
            </Row> */}
          </Container>
        </div>
      </div>
    </>
  );
}

export default Home;



